import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLButtonElement> {
  triggerClicked(): void {
    const label = document.querySelector('#top-jump-search-label') as HTMLLabelElement
    if (label !== null) {
      label.classList.toggle('hidden')
    }
  }
}
